import * as Enum from '../dtos/enums';
import { Conditional } from '@angular/compiler';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

export class ConfigHelper {

    public static setTestTypeId(testTypeId: number) {
        _paragonConfig.testTypeId = +testTypeId;
    }

    public static getTestTypeId(): number {
        return _paragonConfig.testTypeId;
    }

    public static isIppMode() {
        return _paragonConfig.mode === "ipp";
    }

    public static isTdpMode(webDelivery: boolean = null) {
        if (webDelivery === true) {
            return _paragonConfig.mode === "tdp_web_delivey";
        } else if (webDelivery === false) {
            return _paragonConfig.mode === "tdp";
        } else {
            return _paragonConfig.mode === "tdp" || _paragonConfig.mode === "tdp_web_delivey";
        }
    }

    public static isPreviewMode() {
        return _paragonConfig.mode === "preview";
    }

    public static testContentServerApiUrl() {
        return _paragonConfig.testContentServerApiUrl;
    }

    public static testServerApiUrl() {
        return _paragonConfig.testServerApiUrl;
    }

    public static getAudioAssetUrl(): string {
        if (this.isTdpMode()) {
            return `${_paragonConfig.testContentServerApiUrl}/assets/audio`;
        } if (this.isIppMode()) {
            return `${_paragonConfig.testContentServerApiUrl}/Content/RenderingEngine/assets/audio`;
        } else {
            return `${_paragonConfig.testContentServerApiUrl}/Content/Preview/assets/audio`;
        }
    }

    public static shouldUseBeepAudioClipForSpeaking(testTypeId: Enum.TestTypeEnum) {
        switch (testTypeId) {
            case Enum.TestTypeEnum.CAEL:
                return true;
            default:
                return false;
        }
    }

    public static shouldShowTimesUpDlgForSpeaking(testTypeId: Enum.TestTypeEnum) {
        switch (testTypeId) {
            case Enum.TestTypeEnum.CAEL:
                return false;
            default:
                return true;
        }
    }

    public static shouldCheckForUnacceptableRecording(testTypeId: Enum.TestTypeEnum) {
        if (this.isIppMode() || this.isPreviewMode() || this.isTdpMode(true)) {
            return false;
        }
        if (!testTypeId || testTypeId === Enum.TestTypeEnum.CAEL) {
            return false;
        }
        return true;
    }

    public static shouldAlwaysHideNextButton() {
        switch (ConfigHelper.getTestTypeId()) {
            case Enum.TestTypeEnum.CAEL:
                return true;
            default:
                return false;
        }
    }

    public static canSkipMicrophoneCheck() {
        return (this.isIppMode() || this.isPreviewMode());
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/config.helper.ts